import moment from '../helpers/moment'
import undoable, { includeAction } from 'redux-undo'
import * as shiftsActions from '../actions/shifts'

const initialState = {
  shiftsEditMode: false,
  shifts: []
}

const shifts = (state = initialState, action) => {
  switch (action.type) {
  case shiftsActions.SHIFTS_GOTO_EDIT_MODE:
    return {
      ...state,
      shiftsEditMode: action.editMode
    }

  case shiftsActions.LOADSHIFTS_REQUESTED:
    return {
      ...state,
      id: action.id,
      isLoading: true
    }

  case shiftsActions.SHIFTS_LOADED:
    action.data.shifts.forEach(item => item.startEdit = item.start) //Copy start date (primary key) to editable field
    return {
      ...state,
      shifts: action.data.shifts,
      isLoading: false
    }

  case shiftsActions.LOADSHIFTS_ERROR:
    return {
      ...state,
      error: action.error,
      isLoading: false
    }

  case shiftsActions.SHIFT_ON_CHANGE:
    const updatedItems = state.shifts.map(item => {
      if (item.start === action.shift.start) {
        action.shift.start = action.shift.startEdit
        return { ...item, ...action.shift }
      }
      return item
    })
    return {
      ...state,
      shifts: updatedItems
    }

  case shiftsActions.ADD_SHIFT:
    let newStart = moment(action.activeDate).startOf('day')
    const timeAlreadyExists = newStart => 0 < state.shifts.filter(item => newStart.isSame(item.start)).length

    while (timeAlreadyExists(newStart)) {
      newStart = newStart.add(15, 'minutes')
    }
    let startString = newStart.toISOString()

    return {
      ...state,
      shifts: [{ start: startString, startEdit: startString, activeDrivers: 0, changed: true, newShift: true }, ...state.shifts]
    }

  case shiftsActions.SAVESHIFTS_REQUESTED:
    return {
      ...state,
      poolId: action.poolId,
      isLoading: true
    }

  case shiftsActions.SHIFTS_SAVED:
    return {
      ...state,
      isLoading: false,
      shifts: action.shifts
    }

  case shiftsActions.SAVESHIFTS_ERROR:
    return {
      ...state,
      isLoading: false
    }

  default:
    return state
  }

}

const undoableShifts = undoable(shifts, {
  filter: includeAction([shiftsActions.SHIFT_ON_CHANGE, shiftsActions.ADD_SHIFT])
})

export default undoableShifts



// WEBPACK FOOTER //
// ./src/reducers/shifts.js